var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #707070;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-1",
    d: "M9.038,17.347l3.375-3.4a2.294,2.294,0,0,0,0-3.165A2.207,2.207,0,0,0,9,10.66L4.375,15.314A4.582,4.582,0,0,0,3,18.585a4.72,4.72,0,0,0,1.25,3.145,4.659,4.659,0,0,0,6.5,0L21.625,10.786A4.582,4.582,0,0,0,23,7.515a5.325,5.325,0,0,0-1.125-3.145,4.659,4.659,0,0,0-6.5,0c.053-.04-2.587,2.419-2.587,2.419",
    transform: "translate(-2 -2.051)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.1277db260dc7ff97321f10a9ee6ecf22.svg";
export { ForwardRef as ReactComponent };